export const goodsCouponModule = {
  title: "商品券",
  historyTitle: "最近の使用履歴",
  historyTableTitle: "商品券名",
  historyTableDate: "日時",
  historyTablePrice: "金額",
  actionButton: "マイ商品券をチャージする",
  moreTitle: "すべてのマイ商品券を見る",
  couponAmountSelect: "商品券選択",
  pay: "チャージ",
  payPrice: "チャージ金額",
  usablePrice: "ご利用可能額：",
  usePrice: "ご利用額：",
  leftPrice: "残高：",
  useButton: "利用する",
  cancelButton: "キャンセル",
  confirmButton: "確定",
  useTip: "この画面を店員にお見せください。<br>上記の内容でお支払いを確定します。",
  priceInputError: "金額入力エラー",
  hasBuy: "購入済み",
  notBuy: "未購入",
  couponUseSuccess: "ご利用ありがとうございました。",
  couponBuySuccess: "ご注文ありがとうございました。",
  goCouponList: "商品券一覧",
  goUseCoupon: "使用券",
  goHome: "トップページへ",
  payButton: "チャージする",
};
